export enum RoundType {
  ZERO,
  SM,
  MD,
  LG,
  XL,
  PILL,
  CIRCLE
}
